import React, { Component, Fragment } from 'react';
import { MutationFunction, MutationResult } from 'react-apollo';
import { Trans } from 'react-i18next';
import { FormikValues } from 'formik';
import { Button, Divider, Card, CardHeader, CardContent, Typography } from '@material-ui/core';
import { withStyles, WithStyles } from '@material-ui/core/styles';

import { Loaders } from 'components';
import { getEmbed, isEmbed } from 'features/content/helpers';
import { Image, Provider, Title } from 'features/content/widgets';

import { RemoveTypes } from '../../types';
import styles from './styles';

interface IProps extends WithStyles<typeof styles> {
  mutate?: MutationFunction;
  mutateOptions?: MutationResult;
  values?: FormikValues;
  onRemove?: (type: RemoveTypes) => () => void;
}

class Url extends Component<IProps> {
  static defaultProps = {
    mutateOptions: {} as MutationResult,
  };

  componentDidMount() {
    const { mutate } = this.props;

    if (mutate) {
      mutate();
    }
  }

  getContent() {
    const { values, mutateOptions } = this.props;

    return mutateOptions.data ? mutateOptions.data.processContent : values;
  }

  getContentSection() {
    const { classes } = this.props;
    const content = this.getContent();

    if (isEmbed(content)) {
      return <div className={classes.align}>{getEmbed(content)}</div>;
    }

    const { content_object } = content;
    const { title } = content_object.url_metadata;

    return (
      <Fragment>
        <Image content={content} />
        <CardContent className={classes.cardBody}>
          <Title title={title} />
        </CardContent>
      </Fragment>
    );
  }

  renderPreview() {
    const { classes, onRemove } = this.props;
    const content = this.getContent();

    return (
      <Card elevation={0} className={classes.card} square>
        <Divider />
        <CardHeader
          classes={{ root: classes.cardHeaderRoot }}
          title={<Provider content={content} />}
          action={
            onRemove && (
              <Button className={classes.button} onClick={onRemove(RemoveTypes.Url)}>
                <Trans i18nKey="posting:removePreview" />
              </Button>
            )
          }
        />
        {this.getContentSection()}
      </Card>
    );
  }

  renderUnavailable = () => {
    const { classes, onRemove } = this.props;

    return (
      <Card className={classes.card} square>
        <Divider />
        <CardHeader
          classes={{ root: classes.cardHeaderRoot }}
          action={
            onRemove && (
              <Button className={classes.button} onClick={onRemove(RemoveTypes.Url)}>
                <Trans i18nKey="posting:removePreview" />
              </Button>
            )
          }
        />
        <div className={classes.unavailable}>
          <Typography>
            <Trans i18nKey="posting:previewUnavailable" />
          </Typography>
        </div>
      </Card>
    );
  };

  render() {
    const { classes, mutateOptions, values } = this.props;
    const { data, loading, error } = mutateOptions;

    if (error) {
      return this.renderUnavailable();
    }

    return (
      <div className={classes.placeholder}>
        {loading && <Loaders.Standard />}
        {(values || data) && this.renderPreview()}
      </div>
    );
  }
}

export default withStyles(styles)(Url);
